<template>
	<div class="button-group-view">
		<div :class="{
			action: true,
			selected: value == action.value
		}" v-for="(action, i) in actions" :key="i" @click="onClick($event, action.value)" v-html="action.label"></div>
	</div>
</template>

<script>
	export default {
		props: {
			actions: {
				type: Array,
				default() {
					return [];
				}
			},
			value: {
				type: [String, Boolean, Object],
				default: null
			}
		},
		methods: {
			onClick(e, value) {
				this.$emit('onClick', e, value);
				this.$emit('input', value);
			}
		}
	}
</script>

<style lang="scss" scoped>
	.button-group-view {
		overflow: hidden;
		border-radius: 20px;
		border: 1px solid #cecece;

		& > .action {
			float: left;
			padding: 0 30px 0 30px;
			line-height: 38px;
			cursor: pointer;
			border-left: 1px solid #cecece;
			background-color: #f0f0f0;
			color: #979797;

			&.selected {
				background-color: white;
				color: black;
			}

			&:first-child {
				border-left: none;
			}
		}
	}
</style>